// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/OperacaoServiceOrders_StockResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /dashboards/operacao_service_orders/stock.
 *
 * Surfaces the two pieces of the Op·SO stock widget:
 *   - `low_stock`     : products at/below their minimum_quantity threshold
 *   - `recent_movements`: last N stock movements (entry / exit), most recent first
 */
import type { OperacaoServiceOrders_LowStockRow } from './OperacaoServiceOrders_LowStockRow'
import type { OperacaoServiceOrders_StockMovementRow } from './OperacaoServiceOrders_StockMovementRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface OperacaoServiceOrders_StockResponseDados {
low_stock: OperacaoServiceOrders_LowStockRow[]
recent_movements: OperacaoServiceOrders_StockMovementRow[]
}

export type OperacaoServiceOrders_StockResponse = ApiResponse<OperacaoServiceOrders_StockResponseDados>;

registerResponseContract('OperacaoServiceOrders_StockResponse', {
  low_stock: {
    type: 'array',
    required: true,
    items: {
      product_id:       { type: 'number',  required: true },
      product_name:     { type: 'string',  required: true },
      quantity:         { type: 'number',  required: true },
      minimum_quantity: { type: 'number',  required: true },
      franchise_id:     { type: 'number',  required: true },
    },
  },
  recent_movements: {
    type: 'array',
    required: true,
    items: {
      movement_id:   { type: 'number',  required: true },
      product_id:    { type: 'number',  required: true },
      product_name:  { type: 'string',  required: true },
      movement_type: { type: 'string',  required: true },
      quantity:      { type: 'number',  required: true },
      notes:         { type: 'string',  required: false },
      franchise_id:  { type: 'number',  required: true },
      created_at:    { type: 'string',  required: true },
    },
  },
})
